module.exports = __webpack_public_path__ + "staticcomp/img/top_logo.6d9d5ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top_logo.png
// module id = 1dbQ
// module chunks = 39